import cx from 'classnames';
import moment from 'moment-jalaali';
import { Award, GitCommit } from 'tabler-icons-react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedMarker } from 'Actions';
import { slugify, Names } from 'Utils';
import { Avatar } from 'Elements';
import styles from 'partials/sidebar-item.module.scss';
moment.loadPersian({ dialect: 'persian-modern' });

export const SidebarItem = ({ data, onClick }) => {
	const dispatch = useDispatch();

	const handleClick = () => {
		// history.push(`/story/${data.id}/${slugify(data.slug)}`);
		dispatch(setSelectedMarker(data));
		onClick?.();
	};

	// useEffect(() => {
	// 	axios.get('https://jsonplaceholder.typicode.com/photos').then((res) => {
	// 		console.log('res: ', res);
	// 		setPic(res.data);
	// 	});
	// }, []);

	return (
		<div className={styles.box}>
			<h3
				role="presentation"
				className={styles.title}
				onClick={handleClick}
				onKeyPress={handleClick}>
				<Link
					to={`${Names.story.path}/${data.id}/${slugify(data.slug)}`}>
					<span>{data.title}</span>
				</Link>
			</h3>
			<div className={styles.meta}>
				<div className={styles.avatars}>
					{data.persons.slice(0, 5).map((elem) => {
						return (
							<Avatar
								key={elem.id}
								alt={elem.full_name}
								src={elem.avatar}
								className={styles.avatar}
							/>
						);
					})}
					{data.persons.length > 5 && (
						<div className={styles.avatarCounter}>
							+{data.persons.length - 5}
						</div>
					)}
				</div>
				<span className={styles.metaText}>
					{data.location.city.name}
				</span>
				<span className={styles.metaText}>
					{moment.unix(data.start_date).format('jYYYY')}
				</span>
				<div className={styles.icons}>
					{data.is_verify === 1 && (
						<Award className={cx(styles.icon, styles.iconBadge)} />
					)}
					{data.is_section === 1 && (
						<GitCommit
							className={cx(styles.icon, styles.iconSeq)}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
